module.exports = __webpack_public_path__ + "img/m2.21c26bb7.svg";